import React, { useEffect } from "react";
import { useBlocker, useBeforeUnload } from "react-router-dom";

const defaultMessage = "You have not saved the form. Any changes will be lost if you leave this page.";

const usePromptOnNavigate = (shouldPrompt:boolean, message:string = defaultMessage):void => {
  const blocker = useBlocker(shouldPrompt);

  useEffect(() => {
    if (blocker.state === "blocked") {
      // eslint-disable-next-line no-alert
      const confirmed = shouldPrompt ? window.confirm(message) : true;
      if (confirmed) {
        blocker.proceed();
      } else {
        blocker.reset();
      }
    }
  }, [blocker, message, shouldPrompt]);

  useBeforeUnload((event: BeforeUnloadEvent) => {
    if (!shouldPrompt) return;
    event.preventDefault();
    // Some browsers require returnValue to be set for the prompt to show
    event.returnValue = "";
  });
};

const PromptOnNavigate:React.FC<{shouldPrompt:boolean, message?:string}> =
({ shouldPrompt, message }) => {
  usePromptOnNavigate(shouldPrompt, message);

  return null;
};

export { usePromptOnNavigate, PromptOnNavigate };
